import { Injectable } from '@angular/core'
import { ActivatedRoute, Router, UrlSerializer, UrlTree } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class GbNavigationService {
  constructor(private router: Router, private urlSerializer: UrlSerializer) {}

  navigate(
    fragments: string[] | string,
    options: { activatedRoute?: ActivatedRoute; newTab?: boolean; params?: {} } = {},
  ) {
    options.newTab
      ? this.newTabNavigation(fragments, options.activatedRoute, options.params)
      : this.sameTabNavigation(fragments, options.activatedRoute, options.params)
  }

  sameTabNavigation(fragments: string[] | string, activatedRoute?: ActivatedRoute, params?: {}) {
    const routeToNavigate = Array.isArray(fragments) ? fragments : [fragments]

    const tree = this.router.createUrlTree(routeToNavigate, {
      relativeTo: activatedRoute || this.router.routerState.root,
      queryParams: params,
    })

    this.router.navigateByUrl(tree)
  }

  newTabNavigation(fragments: string[] | string, activatedRoute?: ActivatedRoute, params?: {}) {
    if (fragments instanceof Array) {
      const newTabUrl =
        window.location.origin + this.urlSerializer.serialize(this.getTree(fragments, activatedRoute, params))
      window.open(newTabUrl, '_blank')
    } else {
      const fullUrl =
        window.location.origin + this.urlSerializer.serialize(this.getTree(fragments, activatedRoute, params))
      window.open(fullUrl, '_blank')
    }
  }

  getTree(fragments: string[] | string, activatedRoute?: ActivatedRoute, params?: {}): UrlTree {
    const tree = this.router.createUrlTree(fragments instanceof Array ? fragments : [fragments], {
      relativeTo: activatedRoute,
      queryParams: params,
    })

    return tree
  }
}
